module.exports = __webpack_public_path__ + "static/media/tree_20.f4345596.jpg";